export class AccountSettingsBaseInfo {
  name: string;
  allowedUrls: string[];
}

export interface AccountCustomFont {
  id?: string;
  createdTime?: Date;
  updatedTime?: Date;
  name?: string;
  displayName?: string;
  cssLink?: string;
  siteId?: number;
  // New settings
  type?: AccountCustomFontType;
  fontFiles?: Array<AccountCustomFontFile>;
  injectOnRendering?: boolean;
}

export enum AccountCustomFontType {
  Default = 'Default',
  CssLink = 'CssLink',
  UploadedFont = 'UploadedFont',
}

export interface AccountCustomFontFile {
  url?: string;
  type?: AccountCustomFontFileType;
  weight?: number;
  style?: AccountCustomFontFileStyle;
  // Rendering properties
  fileName?: string;
}

export enum AccountCustomFontFileType {
  Woff = 'Woff',
  Woff2 = 'Woff2',
  Otf = 'Otf', // format('opentype')
  Ttf = 'Ttf',
}

export enum AccountCustomFontFileStyle {
  Normal = 'Normal',
  Italic = 'Italic',
}

export interface AccountVariable {
  id?: string;
  key?: string;
  createdTime?: Date;
  updatedTime?: Date;
  siteId?: number;
  type: AccountVariableType;
  value?: string;
  description?: string;
  saveDisabled?: boolean;
}

export enum AccountVariableType {
  Text = 'Text',
  Font = 'Font',
  Color = 'Color',
}
